import { render, staticRenderFns } from "./KnFinancialVarTuitions.vue?vue&type=template&id=2572ea07"
import script from "./KnFinancialVarTuitions.js?vue&type=script&lang=js&external"
export * from "./KnFinancialVarTuitions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports